var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEllipse7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 16.8913C22 19.1605 20.1162 21 17.7924 21H4.20763C1.88382 21 0 19.1605 0 16.8913V4.10874C0 1.83954 1.88382 0 4.20763 0H17.7924C20.1162 0 22 1.83955 22 4.10874V16.8913ZM10.7036 15.9948C10.8955 16.0675 11.1065 16.0675 11.296 15.9948V15.9925C14.3345 14.8474 16.3418 11.995 16.3442 8.81476V6.4706C16.3442 6.02799 15.9749 5.66735 15.5216 5.66735H6.47796C6.02471 5.66735 5.65538 6.02799 5.65538 6.4706V8.81476C5.66018 11.9974 7.66508 14.8497 10.7036 15.9948Z",
    fill: "#FF0055"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEllipse7);
export default __webpack_public_path__ + "static/media/ellipse7.9abeec7d355cb04f96bcd9b312d250c8.svg";
export { ForwardRef as ReactComponent };